import styled from "styled-components";
import { pxToRem } from "styles/utils";

export const ButtonContainer = styled.div<{ $tone?: "default" | "danger" }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Иконка действия не ужимается под нехватку места: в узкой колонке
     кнопка должна остаться кликабельной, а не превратиться в полоску. */
  flex: 0 0 auto;
  width: ${pxToRem(34)};
  padding: ${({ theme }) => pxToRem(theme.radii.sm)};
  border: none;
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: transparent;
  color: inherit;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, transform 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.inkSurface};
    transform: scale(1.05);
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(1)};
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

export const Tooltip = styled.div<{ visible?: boolean }>`
  position: absolute;
  bottom: 100%;
  left: 50%;
  z-index: 1000;
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
  opacity: ${({ visible }) => (visible ? "1" : "0")};
  padding: ${({ theme }) => pxToRem(theme.spacing.xxs)} ${({ theme }) => pxToRem(theme.spacing.xs)};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xs)};
  text-align: center;
  transform: translateX(-50%);
  transition: opacity 0.3s ease;
`;
